import BackButton from "@components/TopBar/BackButton";
import PageTitle from "@components/TopBar/PageTitle";
import { Stack } from "expo-router";

export const unstable_settings = {
  initialRouteName: "index",
};

export default function InboxStack() {
  return (
    <Stack
      screenOptions={{
        headerBackVisible: false,
        headerLeft: () => <BackButton />,
        headerRight: () => null,
        headerShadowVisible: false,
        headerShown: true,
        headerTitle: () => <PageTitle title="Inbox" />,
        headerTitleAlign: "center",
        headerTransparent: true,
      }}
    >
      <Stack.Screen name="index" options={{ animation: "none" }} />
      <Stack.Screen name="[inboxItemId]" />
    </Stack>
  );
}
